import React from "react";
import DonutChart from "./DonutChart";
import HorizontalBarChart from "./HorizontalBarChart";
import StarRatingChart from "./StarRatingChart";
import OpenEndedResponses from "./OpenEndedResponses";

const QuestionResultRenderer = ({ question, results, openEndedResponses }) => {
	// Find the results that match this question
	const questionResults = results.find(result => result.questionKey === question.key);

	// Filter open-ended responses for this specific question
	const questionOpenEndedResponses = openEndedResponses.filter(response => response.questionKey === question.key);

	// Check for no data based on question type
	const hasNoData =
		question.responseType === "openended"
			? questionOpenEndedResponses.length === 0
			: !questionResults || !questionResults.responses || questionResults.responses.length === 0;

	if (hasNoData) {
		return (
			<div className="chart-container no-data">
				<div className="chart-header">
					<h4>{question.title}</h4>
					{question.subtitle && <p className="chart-subtitle">{question.subtitle}</p>}
				</div>
				<p className="no-data-message">No responses for this question yet.</p>
			</div>
		);
	}

	// Render the appropriate chart based on response type
	switch (question.responseType) {
		case "radio":
			return <DonutChart question={question} results={questionResults} />;

		case "scale":
		case "checkbox":
			return <HorizontalBarChart question={question} results={questionResults} />;

		case "star":
			return <StarRatingChart question={question} results={questionResults} />;

		case "openended":
			return <OpenEndedResponses question={question} responses={questionOpenEndedResponses} />;

		default:
			return null;
	}
};

export default QuestionResultRenderer;
